import React, { useState, useEffect } from "react";
import { Badge, Spinner } from "reactstrap";
import { useTranslation } from "react-i18next";

const SaveStatusBadge = ({ status, message, duration = 5000, onStatusChange }) => {
  const [isVisible, setIsVisible] = useState(true);
  const [isFading, setIsFading] = useState(false);
  const [t] = useTranslation("COMMON");

  useEffect(() => {
    // Reset visibility quando cambia lo status
    if (status !== "idle" && status) {
      setIsVisible(true);
      setIsFading(false);
    }
  }, [status]);

  useEffect(() => {
    if (status === "success" || status === "error") {
      // Inizia la dissolvenza poco prima della fine
      const fadeTimer = setTimeout(() => {
        setIsFading(true);
      }, duration - 500);

      // Nascondi completamente e notifica il parent
      const hideTimer = setTimeout(() => {
        setIsVisible(false);
        if (onStatusChange) {
          onStatusChange("idle");
        }
      }, duration);

      return () => {
        clearTimeout(fadeTimer);
        clearTimeout(hideTimer);
      };
    }
  }, [status, duration, onStatusChange]);

  if (status === "idle" || !status || !isVisible) {
    return null;
  }

  const statusConfig = {
    saving: {
      color: "info",
      icon: (
        <Spinner
          size="sm"
          style={{ width: "12px", height: "12px", marginRight: "5px" }}
        />
      ),
      text: t("SAVE_STATUS_SAVING"),
    },
    success: {
      color: "success",
      icon: "✓ ",
      text: message?.successMessage || t("SAVE_STATUS_SUCCESS"),
    },
    error: {
      color: "danger",
      icon: "✗ ",
      text: message?.errorMessage || t("SAVE_STATUS_ERROR"),
    },
  };

  const config = statusConfig[status];

  if (!config) {
    return null;
  }

  return (
    <Badge
      color={config.color}
      style={{
        fontSize: "12px",
        padding: "6px 10px",
        transition: "opacity 0.5s ease-out",
        opacity: isFading ? 0 : 1,
      }}
    >
      {config.icon}
      {config.text}
    </Badge>
  );
};

export default SaveStatusBadge;
